/*eslint-disable */
var $ = window.jQuery = require('jquery')

import carousel from 'vue-owl-carousel'
export default {
  name: 'project-collaboration-list',
  components: {
    carousel
  },
  props: [],
  data () {
    return {
      popularVideosData:null,
      popularVideosResults:[]
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  },
  watch:{
  },
}